import { BaseApiService } from "../base/base-api.service";
import { PropsFilter } from "../../models/api/props-filter/props-filter";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { CompanyLegalEntityDTO } from "../../models/company-accounts/company-legal-entities";
import { CompanyLegalEntitySTO } from "../../models/company-accounts/company-legal-entities";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export class CompanyLegalEntitiesApiService extends BaseApiService<CompanyLegalEntityDTO, CompanyLegalEntitySTO> {
  constructor() {
    super({
      servicePath: "/CompanyLegalEntities",
      loadItemsPath: "/GetCompanyLegalEntities",
      saveItemsPath: "/SaveCompanyLegalEntities",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "code",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadLegalEntities = async (id?: string) => {
  const response = await new CompanyLegalEntitiesApiService().loadItems(
    {
      ids: !id ? [] : [id],
      createdByUsers: [],
      modifiedByUsers: [],
      isDeleted: false,
    } as PropsFilter,
    "",
    undefined, // so that the default sort is applied
    { pageNumber: 0, pageSize: 1000 }
  );

  toastifyResponse(response, "failed");

  return response;
};
